import { ConferenceType } from '@wui/im'
import { computed, ComputedRef, Ref } from 'vue'

import { useCurrentUser } from '@/shared/composables/current-user'
import { isGuest } from '@/shared/composables/local-storage'
import { Room } from '@/shared/types/store'

export const useModeratedRoom = (room: Ref<Room | undefined> | ComputedRef<Room | undefined>) => {
  const getSubscriberRole = (imLogin: string) => {
    const contact = room.value?.contacts?.find((c) => c.id === imLogin)
    return contact?.role
  }

  const moderators = computed(() => {
    return new Map([...room.value?.subscribers ?? []].filter(([, subscriber]) => {
      const role = getSubscriberRole(subscriber.imLogin)
      return role === 'Owner' || role === 'Moderator'
    }))
  })

  const canIEditRoomInfo = computed(() => {
    if (isGuest()) {
      return false
    }

    if (room.value?.mode !== ConferenceType.MODERATED) {
      return true
    }

    const { currentUser } = useCurrentUser()
    return moderators.value.has(currentUser.value?.imLogin ?? '')
  })

  return {
    canIEditRoomInfo,
    getSubscriberRole,
  }
}
